// extracted by mini-css-extract-plugin
module.exports = {"Links":"Links_Links__qQbLh","AppStore":"Links_AppStore__2RPHA","GooglePlay":"Links_GooglePlay__16_k5"};